import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { queryKeys } from '@/shared/constants/queryKeys';
import routesPath from '@/shared/constants/routesPath';
import FILTER_OPTIONS from '@/shared/constants/topScoresFilterOptions';

import { getTopScores } from '@/services/livescoring';

const FILTERS = {
  [FILTER_OPTIONS.DAY]: 'Day',
  [FILTER_OPTIONS.WEEK]: 'Week',
  [FILTER_OPTIONS.MONTH]: 'Month',
};

const useTopScores = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [filter, setFilter] = useState(FILTER_OPTIONS.WEEK);

  const { data, isLoading, isError } = useQuery({
    queryKey: [queryKeys.topScores, filter, uuid],
    queryFn: () => getTopScores({ uuid }),
    select: ({ data }) => data[filter],
  });

  const goToLiveScores = () => {
    navigate(generatePath(routesPath.LIVESCORING, { uuid }));
  };

  return {
    data,
    isLoading,
    isError,
    filters: {
      labels: FILTERS,
      selected: filter,
      onChange: setFilter,
    },
    goToLiveScores,
  };
};

export default useTopScores;
